const Button1 = ({ children }) => (
    <button className='button-1'>{children}</button>
)
export default Button1